import { render, staticRenderFns } from "./InMapLegendCollapsables.vue?vue&type=template&id=c38821b2&scoped=true"
import script from "./InMapLegendCollapsables.vue?vue&type=script&lang=js"
export * from "./InMapLegendCollapsables.vue?vue&type=script&lang=js"
import style0 from "./InMapLegendCollapsables.vue?vue&type=style&index=0&id=c38821b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38821b2",
  null
  
)

export default component.exports